// Shared keyboard-navigation helper for the searchable combobox pickers
// (SkuSearchSelect + CustomerSearchSelect). Kept React-free so the
// highlight-clamping logic is unit-testable in node vitest.

/** Clamp a highlight index move (arrow keys) into [0, count-1]. Returns 0 when
 *  the list is empty so nothing reads a negative index. */
export function moveHighlight(current: number, delta: number, count: number): number {
  if (count <= 0) return 0;
  const next = current + delta;
  if (next < 0) return 0;
  if (next > count - 1) return count - 1;
  return next;
}
